import React from "react";
import { omit } from "ramda";

const scrollToTop = Component => {
  return class extends React.Component {
    render() {
      return (
        <Component
          {...omit(["scrollTopProp", "scrollTopPropValue"], this.props)}
        />
      );
    }

    doScrollToTop() {
      const node = this.getNode();

      if (node) {
        node.scrollTop = 0;
      }
    }

    componentDidUpdate(prevProps) {
      const scrollTopProp = this.props.scrollTopProp;
      const scrollTopPropValue = this.props.scrollTopPropValue;

      const value = this.props[scrollTopProp];
      const prevValue = prevProps[scrollTopProp];

      if (value !== prevValue && value === scrollTopPropValue) {
        this.doScrollToTop();
      }
    }
  };
};

export default scrollToTop;
